export function isProductionEnv(): boolean {
  return process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === 'PRD';
}

export function isNonProductionEnv(): boolean {
  return !isProductionEnv();
}
